module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.isTowerCo()) ? _c('el-form-item', [_vm._v("\n            Technical Proposal type: "), _c('strong', [_vm._v(_vm._s(_vm.step2p2.state.tpType))])]) : _c('select-tech-proposal', {
    attrs: {
      "disabled": _vm.disabled && !_vm.isApproved
    },
    model: {
      value: (_vm.step.state.tpType),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "tpType", $$v)
      },
      expression: "step.state.tpType"
    }
  })], 1), _vm._v(" "), (_vm.isTelco()) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Site Id",
      "disabled": _vm.disabled && !_vm.isApproved
    },
    model: {
      value: (_vm.step.state.siteId),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "siteId", $$v)
      },
      expression: "step.state.siteId"
    }
  })], 1) : _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Telco Site ID"
    }
  }, [(_vm.isTelco()) ? _c('b', [_vm._v(_vm._s(_vm.step.state.siteId))]) : _c('b', [_vm._v(_vm._s(_vm.step2p2.state.siteId))])])], 1)], 1), _vm._v(" "), (!_vm.isBackhaul) ? _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-service-type', {
    attrs: {
      "disabled": _vm.disabled && !_vm.isApproved
    },
    model: {
      value: (_vm.step2p2.state.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.step2p2.state, "serviceType", $$v)
      },
      expression: "step2p2.state.serviceType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-spectrum', {
    attrs: {
      "disabled": _vm.disabled && !_vm.isApproved
    },
    model: {
      value: (_vm.step2p2.state.spectrumBand),
      callback: function($$v) {
        _vm.$set(_vm.step2p2.state, "spectrumBand", $$v)
      },
      expression: "step2p2.state.spectrumBand"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isTelco()) ? _c('section', [(_vm.step2p1 && _vm.step2p1.approvedStatus && !_vm.isPending) ? _c('div', [_c('el-row', [(_vm.step2p1.approvedStatus !== 'Pending') ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.step2p1.approvedStatus))]), _vm._v(" "), _c('p', [_c('i', [_vm._v(_vm._s(_vm.step2p1.approvedStatus) + " on " + _vm._s(_vm.formatDate(_vm.step2p1.approved_at)))])]), _vm._v(" "), (_vm.step2p1.state.reSurvey || _vm.step2p1.state.reviseTP) ? _c('p', [_c('strong', [_vm._v("Actions Required")])]) : _vm._e(), _vm._v(" "), (_vm.step2p1.state.reSurvey) ? _c('p', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Re-survey Required")]) : _vm._e(), _vm._v(" "), (_vm.step2p1.state.reviseTP) ? _c('p', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Revise Technical Propsal")]) : _vm._e(), _vm._v(" "), (_vm.step2p1.remarks) ? _c('div', [_c('div', {
    staticClass: "html-remarks"
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.step2p1.approvedStatus + ' Remarks')
    }
  }), _vm._v(" "), (_vm.step2p1.remarks) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.step2p1.remarks)
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No remarks")])])]) : _vm._e()]) : _vm._e()], 1)], 1) : _vm._e()]) : _c('section', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.step.remarks) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.step.remarks)
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No remarks")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.showPane),
      callback: function($$v) {
        _vm.showPane = $$v
      },
      expression: "showPane"
    }
  }, [(_vm.isTowerCo()) ? _c('el-collapse-item', {
    attrs: {
      "name": "Approval"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('b', [_vm._v(_vm._s(_vm.step.approvedStatus ? _vm.step.approvedStatus : 'Pending'))]), _vm._v("\n           \n          "), (!_vm.step.approved) ? _c('span', [_vm._v("Approval")]) : _vm._e(), _vm._v("\n           \n          "), (_vm.step.approved) ? _c('i', {
    staticClass: "header-icon fa fa-check-circle text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.step.approvedStatus === 'Conditional') ? _c('i', {
    staticClass: "header-icon fa fa-question-circle text-warning"
  }) : _vm._e(), _vm._v(" "), (_vm.step.approvedStatus === 'Rejected') ? _c('i', {
    staticClass: "header-icon fa fa-exclamation-circle text-danger"
  }) : _vm._e(), _vm._v(" "), (!_vm.step.approved && (_vm.step.approvedStatus !== 'Rejected' && _vm.step.approvedStatus !== 'Conditional')) ? _c('i', {
    staticClass: "header-icon fa fa-info-circle text-muted"
  }) : _vm._e(), _vm._v("\n           \n          "), (_vm.step.approved && _vm.step.approvedStatus === 'Approved') ? _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.step.approved_at)))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Approval"
    }
  }, [_c('select-approval-status', {
    attrs: {
      "disabled": !(!_vm.disabled && _vm.isApprover() && _vm.canAccess('project'))
    },
    on: {
      "change": function($event) {
        return _vm.approval()
      }
    },
    model: {
      value: (_vm.step.approvedStatus),
      callback: function($$v) {
        _vm.$set(_vm.step, "approvedStatus", $$v)
      },
      expression: "step.approvedStatus"
    }
  })], 1), _vm._v(" "), (!_vm.isPending) ? _c('date-input', {
    attrs: {
      "label": "Date",
      "format": _vm.dateFormat,
      "disabled": !(!_vm.disabled && _vm.isApprover() && _vm.canAccess('project'))
    },
    model: {
      value: (_vm.step.approved_at),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_at", $$v)
      },
      expression: "step.approved_at"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPending) ? _c('check-box', {
    attrs: {
      "label": "",
      "disabled": !(!_vm.disabled && _vm.isApprover() && _vm.canAccess('project'))
    },
    model: {
      value: (_vm.step.state.reviseTP),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "reviseTP", $$v)
      },
      expression: "step.state.reviseTP"
    }
  }, [_vm._v("Revise " + _vm._s(_vm.step.state.tpType))]) : _vm._e(), _vm._v(" "), (!_vm.isPending) ? _c('check-box', {
    attrs: {
      "label": "",
      "disabled": !(!_vm.disabled && _vm.isApprover() && _vm.canAccess('project'))
    },
    model: {
      value: (_vm.step.state.reSurvey),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "reSurvey", $$v)
      },
      expression: "step.state.reSurvey"
    }
  }, [_vm._v("Re-survey")]) : _vm._e(), _vm._v(" "), (!_vm.step.approved || !_vm.isViewOnly() || (_vm.isApprover() && _vm.canAccess('project'))) ? _c('el-row', [(_vm.isActive(this.actionData)) ? _c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Please Note",
      "description": "These remarks will be visible to the sharer as well and will be sent in the approval e-mail.",
      "show-icon": ""
    }
  }) : _c('el-alert', {
    attrs: {
      "type": "primary",
      "title": "Approval Remarks",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('html-input', {
    attrs: {
      "cls-style": "height: 34vh; width: 58.8vw; overflow: auto;",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isApprover() && _vm.canAccess('project')) ? _c('el-row', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": _vm.approvalButton,
      "disabled": (!_vm.step.approvedStatus)
    },
    on: {
      "click": function($event) {
        return _vm.sendApproval()
      }
    }
  }, [_vm._v("\n          Send " + _vm._s(_vm.step.approvedStatus) + " e-Mail\n        ")])], 1), _vm._v(" "), (_vm.isRejected) ? _c('el-form-item', [_c('check-box', {
    staticStyle: {
      "background-color": "#faedd9"
    },
    attrs: {
      "border": ""
    },
    on: {
      "change": _vm.setRejected
    }
  }, [_vm._v("Close this Request permanently?")])], 1) : _vm._e()], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.isViewOnly() && (!_vm.step.approved && _vm.step.actionType === 'RTS' && _vm.isActive(this.actionData))) ? _c('el-collapse-item', {
    attrs: {
      "name": "Telco Equipment"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n        Allow Telco to Add Equipment \n        "), (_vm.step.state.allowClientEquipmentInput) ? _c('i', {
    staticClass: "header-icon fa fa-check-circle text-primary"
  }) : _c('i', {
    staticClass: "header-icon fa fa-minus-circle text-warning"
  })]), _vm._v(" "), _c('el-form-item', [_c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.state.allowClientEquipmentInput),
      callback: function($$v) {
        _vm.$set(_vm.step.state, "allowClientEquipmentInput", $$v)
      },
      expression: "step.state.allowClientEquipmentInput"
    }
  }, [_vm._v("Allow Telcos to Input Equipment?")])], 1)], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), ((!_vm.isViewOnly() && _vm.isTowerCo() && (_vm.actionData.status != 'Closed' && _vm.actionData.status != 'Rejected')) || (_vm.isTelco() && _vm.step.state.allowClientEquipmentInput)) ? _c('section', [(!_vm.isViewOnly() && _vm.step.actionType === 'RTS' && !_vm.step.approved) ? _c('el-form', {
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }, [((_vm.isTelco() && _vm.step.state.allowClientEquipmentInput) || (_vm.isTowerCo())) ? _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-top": "0.28em"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 7
    }
  }, [_c('select-equip-category', {
    attrs: {
      "label": "Type",
      "size": "small",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.nameCat
    },
    model: {
      value: (_vm.catType),
      callback: function($$v) {
        _vm.catType = $$v
      },
      expression: "catType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 11,
      "lg": 4
    }
  }, [_c('number-input', {
    attrs: {
      "prop": "qty",
      "label": "Qty",
      "size": "small",
      "min": 1,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.qty),
      callback: function($$v) {
        _vm.$set(_vm.item, "qty", $$v)
      },
      expression: "item.qty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 11,
      "lg": 4
    }
  }, [_c('number-input', {
    attrs: {
      "prop": "setNo",
      "label": "Set #",
      "size": "small",
      "min": 1,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.setNo),
      callback: function($$v) {
        _vm.$set(_vm.item, "setNo", $$v)
      },
      expression: "item.setNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 11,
      "lg": 4
    }
  }, [_c('float-input', {
    attrs: {
      "prop": "size",
      "label": "Dia.",
      "size": "small",
      "suffix": "⌀ mm",
      "min": 1,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.size),
      callback: function($$v) {
        _vm.$set(_vm.item, "size", $$v)
      },
      expression: "item.size"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 11,
      "lg": 4
    }
  }, [_c('float-input', {
    attrs: {
      "prop": "agl",
      "label": "Height",
      "size": "small",
      "suffix": "AGL",
      "min": 0,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.agl),
      callback: function($$v) {
        _vm.$set(_vm.item, "agl", $$v)
      },
      expression: "item.agl"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": _vm.isTelco() ? 3 : 4
    }
  }, [(_vm.isTowerCo()) ? _c('el-form-item', {
    attrs: {
      "prop": "billable",
      "label": 'Billable ' + _vm.money
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "size": "small",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.billable),
      callback: function($$v) {
        _vm.$set(_vm.item, "billable", $$v)
      },
      expression: "item.billable"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.item.billable) ? _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 11,
      "md": 5,
      "lg": 5,
      "offset": 1
    }
  }, [_c('float-input', {
    attrs: {
      "prop": "amount",
      "label": "Amount",
      "size": "small",
      "prefix": _vm.money,
      "min": 0,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.amount),
      callback: function($$v) {
        _vm.$set(_vm.item, "amount", $$v)
      },
      expression: "item.amount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.billable) ? _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 11,
      "md": 6,
      "lg": 5,
      "offset": 1
    }
  }, [_c('select-frequency', {
    attrs: {
      "size": "small",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.item.frequency),
      callback: function($$v) {
        _vm.$set(_vm.item, "frequency", $$v)
      },
      expression: "item.frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled && !_vm.step.approved) ? _c('el-col', {
    attrs: {
      "align": "right",
      "xs": 24,
      "sm": 12,
      "md": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "padding-top": "2.5em"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": this.isDesktop ? 'large' : 'small',
      "icon": "fa fa-plus",
      "disabled": !_vm.item.name && !_vm.item.quantity > 0
    },
    on: {
      "click": function($event) {
        return _vm.addRow()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isDesktop ? 'Add' : '') + "\n        ")])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.equipment && _vm.equipment.length > 0) ? _c('section', [_c('br'), _vm._v(" "), _c('h4', [_vm._v("Equipment")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.equipment,
      "show-summary": "",
      "sum-text": "Totals",
      "border": "",
      "stripe": "",
      "max-height": "300"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Type",
      "width": this.isDesktop ? 396 : 220,
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "prop": "setNo",
      "label": "Set #",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "prop": "size",
      "label": "Size",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "prop": "agl",
      "label": "AGL",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "prop": "billable",
      "label": "Billable"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('b', [_vm._v(_vm._s(_vm.equipment[scope.$index].billable ? 'Y' : 'N'))])]
      }
    }], null, false, 2960382599)
  }), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-table-column', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "prop": "amount",
      "label": _vm.money
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.equipment[scope.$index].amount) ? _c('span', [_vm._v(_vm._s(_vm.formatNumber(_vm.equipment[scope.$index].amount)))]) : _vm._e(), _vm._v(" "), (_vm.equipment[scope.$index].frequency) ? _c('i', {
          staticClass: "text-muted"
        }, [_c('small', [_vm._v(_vm._s(_vm.equipment[scope.$index].frequency))]), _vm._v(" ")]) : _vm._e()]
      }
    }], null, false, 2851286659)
  }) : _vm._e(), _vm._v(" "), (!_vm.disabled && !_vm.step.approved && (this.isTelco() ? _vm.step.state.allowClientEquipmentInput : true)) ? _c('el-table-column', {
    attrs: {
      "label": "=",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isTowerCo() && !_vm.step.approved || (_vm.isTelco() && _vm.equipment[scope.$index].addedByClient)) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "fa fa-trash-alt",
            "size": "mini",
            "circle": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteRow(scope.$index, _vm.equipment)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 4073714356)
  }) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.actionData.actionType !== 'RTS') ? _c('section', [_c('equip-table', {
    attrs: {
      "title": (_vm.isBackhaul ? 'Backhaul' : _vm.actionData.organisation.shortName) + ' Equipment',
      "site-id": _vm.actionData.site_id,
      "owner-id": _vm.actionData.organisation_id,
      "site-data": _vm.actionData.site,
      "filter-col": _vm.isBackhaul ? 'type' : null,
      "filter-val": _vm.isBackhaul ? 'backhaul' : null
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actionData.actionType === _vm.RTD) ? _c('html-input', {
    attrs: {
      "cls-style": "height: 34vh; width: 58.8vw; overflow: auto;",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ababfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/step2.vue
// module id = 1424
// module chunks = 0